module.exports = __webpack_public_path__ + "static/thumbnail-core-93a6f02ac410313abab06ba9b4b40bf6.png";